"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PopoverWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var PopoverWrapper = (0, _styledComponents["default"])(_popover["default"]).withConfig({
  displayName: "Popoverstyles__PopoverWrapper",
  componentId: "sc-54yfzb-0"
})(["display:inline-block;width:100%;"]);
exports.PopoverWrapper = PopoverWrapper;
//# sourceMappingURL=Popover.styles.js.map